import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { SearchModule } from '@app/modules/search/search.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Angulartics2Module } from 'angulartics2';
import { MJSJobRoutingModule } from './mjs-job-routing.module';
import { MJSJobComponent } from './mjs-job.component';
import { NgxFilesizeModule } from "@node_modules/ngx-filesize";

@NgModule({
  declarations: [
    MJSJobComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SearchModule,
    LazyLoadImageModule,
    Angulartics2Module,
    MJSJobRoutingModule,
    NgxFilesizeModule
  ]
})
export class MJSJobModule { }
